import React, { createContext, PropsWithChildren, useContext } from "react";
import { AnalyticsInstance } from "analytics";

const AnalyticsContext = createContext<AnalyticsInstance | undefined>(undefined);

export interface AnalyticsProviderProps {
  analytics: AnalyticsInstance;
}

const AnalyticsProvider = ({ analytics, children }: PropsWithChildren<AnalyticsProviderProps>) => {
  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

const useAnalytics = () => {
  const context = useContext(AnalyticsContext);

  if (context === undefined) {
    throw new Error("useAnalytics must be used within an AnalyticsProvider");
  }

  return context;
};

export { AnalyticsProvider, useAnalytics };
